import { Separator, Stack, Text } from '@fluentui/react';
import { ApprovalHistory } from 'common/components/ApprovalHistory';
import { useCommonStyles } from 'common/styles';
import { FlowApproval } from 'settings/account/intuitiveApprovalSetupFlow/__generated__/FlowApproval';

export const ApprovalHistoryView: React.FC<{
  approvalDetails: FlowApproval | undefined;
  isNew: boolean;
}> = ({ approvalDetails, isNew }) => {
  const commonStyles = useCommonStyles();

  const { approvalHistoriesByEntityId } = { ...approvalDetails?.approval };
  return (
    <Stack>
      {approvalHistoriesByEntityId &&
        approvalHistoriesByEntityId.nodes.length! > 0 &&
        !isNew && (
          <Stack
            styles={{ root: { width: '50%' } }}
            tokens={{ childrenGap: 20 }}
          >
            <Text variant="xLarge">Approval History</Text>
            <Text variant="medium" className={commonStyles.bold}>
              Requested By:
            </Text>
            <ApprovalHistory
              data={approvalHistoriesByEntityId.nodes}
              RemoveAmount
            />
          </Stack>
        )}
    </Stack>
  );
};
